module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/performance-grey.0e825921.svg";